import { formatCurrency } from '../formatCurrency'
import { formatPrice } from '../formatPrice'

export const getPropertyListingPrice = (priceToFormat: number | null, abbreviate = false) => {
  return abbreviate ? formatPrice(priceToFormat) : formatCurrency(priceToFormat)
}
